import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {StudentTicketMandateHolderDto} from "../../../models/student-ticket/payment/StudentTicketMandateHolderDto";
import {Observable} from "rxjs";
import {HttpHeaderService} from "../../utils/http/http-header.service";

@Injectable({
  providedIn: 'root'
})
export class StudentTicketPaymentService {
  configUrl = 'api/student-ticket/payment';

  constructor(
    private readonly http: HttpClient,
    private readonly headerService: HttpHeaderService
  ) {}

  updatePaymentInformation(uuid: string, dto: StudentTicketMandateHolderDto): Observable<StudentTicketMandateHolderDto>{
    return this.http.post<StudentTicketMandateHolderDto>(`${this.configUrl}/${uuid}/mandate-holder`, dto, {headers: this.headerService.getAuthHeader()});
  }
}
